export default __webpack_public_path__ + "static/media/tlou_death_01.21c8067d.mp4";